$(document).ready(function () {
  let kgGpoCurrentStep = 1;
  let kgMaxSteps = 0;
  const kgMysteryGetProductStep = $(".kg-mystery-purchase-getproduct-step");
  console.log(kgMysteryGetProductStep.length);
  const kgProductFormSubmitBtn = $(".atc-button.product-form__submit");

  async function kgCustomCartAction(actionType, kgProductVariantId, kgProductQuantity = 1) {
    if (actionType !== 'add' && actionType !== 'remove') {
      console.error('[KG Cart] Invalid action type:', actionType);
      return;
    }

    const url = `/cart/${actionType}.js`;
    const body = actionType === 'add'
      ? { id: kgProductVariantId, quantity: kgProductQuantity }
      : { id: kgProductVariantId, quantity: 0 };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      if (!response.ok) throw new Error('Failed to ' + actionType + ' item');

      const data = await response.json();
      console.log(`[KG Cart] "${actionType}" action successful ✅`, data);

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: data }
      }));
    } catch (error) {
      console.error(`[KG Cart] "${actionType}" action error ❌`, error);
    }
  }


  function kgGetMaxSteps(kgAllGopGroups) {
    let maxSteps = 0;

    kgAllGopGroups.each(function () {
      const className = $(this).attr("class") || "";

      // Split by space without regex
      const classes = className.split(" ");

      for (let i = 0; i < classes.length; i++) {
        const cls = classes[i];
        if (cls.indexOf("kg-mystery-form-group-") === 0) {
          const stepNum = parseInt(cls.substring("kg-mystery-form-group-".length), 10);
          if (!isNaN(stepNum) && stepNum > maxSteps) {
            maxSteps = stepNum;
          }
        }
      }
    });

    return maxSteps; // highest step number
  }

  function kgUpdateSteps(kgAllGopGroups) {
    // Hide all except current step + step toggle wrapper
    const kgHideGpoGroups = kgAllGopGroups.filter(
      ":not(.kg-mystery-form-group-" + kgGpoCurrentStep + "):not(.kg-mystery-form-steps-toggle-wrapper):not(.kg-no-js-intract)"
    );
    const kgShowGpoGroup = kgAllGopGroups.filter(".kg-mystery-form-group-" + kgGpoCurrentStep + ":not(.kg-no-js-intract)");
    const kgHideNoJsIntractGroups = kgAllGopGroups.filter(":not(.kg-mystery-form-group-" + kgGpoCurrentStep + ").kg-no-js-intract");
    const kgShowNoJsIntractGroups = kgAllGopGroups.filter(".kg-mystery-form-group-" + kgGpoCurrentStep + '.kg-no-js-intract[data-clo-display="hide"]');
    const kgCurrentRemoveInlineCssGroups = kgAllGopGroups.filter(".kg-mystery-form-group-" + kgGpoCurrentStep + '.kg-no-js-intract');

    kgHideGpoGroups.hide();
    kgShowGpoGroup.show();
    kgHideNoJsIntractGroups.hide();
    kgShowNoJsIntractGroups.show();
    kgCurrentRemoveInlineCssGroups.css("display", "");
    kgUpdateGPOProductPrice();

    console.log("Current step:", kgGpoCurrentStep);
  }

  function kgSetMysteryFormStepToggle(kgGpoStepsToglleWrapper, kgAllGopGroups, kgAllGpoGroupsWrapper) {
    const kgGpoStepToggleButtons = kgGpoStepsToglleWrapper.find(".gpo-choicelist.gpo-checkbox.gpo-ov-item");
    kgMaxSteps = kgGetMaxSteps(kgAllGopGroups);
    console.log(kgMaxSteps);

    if (kgGpoStepToggleButtons.length > 0) {
      // hide "prev" button initially
      kgGpoStepToggleButtons.eq(0).hide();
      kgGpoStepsToglleWrapper.show();

      // clear previous events
      kgGpoStepToggleButtons.off("change");
      $(".atc-button.product-form__submit").first().trigger("click");

      // bind handler
      kgGpoStepToggleButtons.on("change", function () {
        const index = kgGpoStepToggleButtons.index(this); // safer indexing
        console.log("Clicked index:", index);

        kgGpoStepToggleButtons.eq(1).show();
        kgMysteryGetProductStep.hide();
        kgProductFormSubmitBtn.hide();

        if (kgGpoCurrentStep === kgMaxSteps) {
          console.log("Already at last step, cannot go further.");
          const kgLetestProductPrice = $(".kg-main-product-page-price").find(".price-item.price-item--regular");
          if (kgLetestProductPrice.length > 0) {
            kgMysteryGetProductStep.find(".kg-card-head-price").html(kgLetestProductPrice.html());
          }
          kgMysteryGetProductStep.show();
          kgGpoStepToggleButtons.eq(1).hide();
          // kgProductFormSubmitBtn.show();

        }

        if (index === 0) {
          // Prev
          if (kgGpoCurrentStep > 1) {
            kgGpoCurrentStep--;
          }
        } else {
          const kgMainGpoContainer = $(".gpo-container");
          const kgAllGpoGroupsWrapper = kgMainGpoContainer.find(".gpo-group__childs");
          const kgErrorGroups = kgAllGpoGroupsWrapper.find(".gpo-form__group.has-error:visible");
          console.log("Error groups count:", kgErrorGroups.length);
          if (kgErrorGroups.length > 0) {
            $.each(kgErrorGroups, function () {
              const kgItems = $(this).find(".gpo-ov-item");
              kgItems.each(function (index) {
                const item = $(this);
                setTimeout(() => {
                  item.addClass("kg-animate-error");
                  setTimeout(() => {
                    item.removeClass("kg-animate-error");
                  }, 1000); // remove after animation duration
                }, index * 50); // stagger delay (wave effect)
              });
            });
            console.log("Form has errors, cannot proceed to next step.");
            return; // prevent going to next step if there are errors
          }
          // Next
          kgGpoCurrentStep++;
        }

        kgGpoStepToggleButtons.eq(0).hide();
        if (kgGpoCurrentStep > 1) {
          kgGpoStepToggleButtons.eq(0).show();
        }
        console.log(kgGpoCurrentStep);

        kgUpdateSteps(kgAllGopGroups);
      });

      const kgCustomErrorGroups = kgAllGpoGroupsWrapper.find(".gpo-form__group.kg-has-error");
      kgCustomErrorGroups.removeClass("has-success").addClass("has-error");
    }
  }

  function kgGpoCustomInit() {
    const kgMainGpoContainer = $(".gpo-container");

    if (kgMainGpoContainer.length > 0) {
      console.log("Found:", kgMainGpoContainer.length);
      const kgGpoStepsToglleWrapper = kgMainGpoContainer.find(".kg-mystery-form-steps-toggle-wrapper");
      const kgAllGpoGroupsWrapper = kgMainGpoContainer.find(".gpo-group__childs");
      const kgAllGopGroups = kgAllGpoGroupsWrapper.find(".gpo-form__group");
      const kgProductFormSubmitBtn = $(".atc-button.product-form__submit");

      if (kgProductFormSubmitBtn.length > 0) {
        kgProductFormSubmitBtn.hide();
      }

      // start with step 1 visible
      kgUpdateSteps(kgAllGopGroups);

      // hook up buttons
      kgSetMysteryFormStepToggle(kgGpoStepsToglleWrapper, kgAllGopGroups, kgAllGpoGroupsWrapper);

      kgMainGpoContainer.show();
      return true;
    }

    return false;
  }

  if (kgMysteryGetProductStep.length > 0) {
    // keep trying until found
    const intervalId = setInterval(function () {
      const found = kgGpoCustomInit();
      if (found) {
        clearInterval(intervalId);
        console.log("Initialization complete!");
      }
    }, 300);
  }

  $(document).on('click', '.kg-card-head-description-toggle', function () {
    $(".kg-mystery-purchase-getproduct-step").find('.kg-card-head-description').slideToggle();
  });

  $(document).on('click', 'button[data-action]', function () {
    const kgAction = $(this).attr('data-action');
    const kgMainWrapper = $(this).closest('.kg-mystery-upsell-item-atc-content-wrapper');
    const kgQtyInput = kgMainWrapper.find('.kg-mystery-upsell-item-quantity-input');
    let currentValue = parseInt(kgQtyInput.val()) || 0;

    if (kgAction === 'increase') {
      kgQtyInput.val(currentValue + 1);
    } else if (kgAction === 'decrease') {
      if (currentValue > 1) kgQtyInput.val(currentValue - 1);
    }

    if (parseInt(kgMainWrapper.find('.kg-mystery-upsell-item-quantity-input').val()) < 2) {
      kgMainWrapper.find('.kg-mystery-upsell-item-qty-decrease').attr('disabled', true);
    } else {
      kgMainWrapper.find('.kg-mystery-upsell-item-qty-decrease').attr('disabled', false);
    }
  });

  $(document).on('click', '.kg-mystery-upsell-item-atc-button', async function () {
    $(this).toggleClass('kg-atc-loading');
    const kgMainWrapper = $(this).closest('.kg-mystery-upsell-item-atc-content-wrapper');
    const kgQtyInput = kgMainWrapper.find('.kg-mystery-upsell-item-quantity-input');
    console.log(kgQtyInput.val());
    const kgProductVariantId = $(this).attr('data-variant-id');
    const kgQuantity = parseInt(kgQtyInput.val()) || 1;
    await kgCustomCartAction('add', kgProductVariantId, kgQuantity);
    $(this).toggleClass('kg-atc-loading');
  });

  $(document).on('click', '.kg-mystery-purchase-preview-modal-toggle', function () {
    const kgProductPreviewModal = $('.kg-mystery-purchase-preview-modal');
    if (kgProductPreviewModal.length > 0) {
      kgProductPreviewModal.fadeToggle();
    }
  });

  $(document).on("click", ".kg-atc-mystery-product", async function () {
    const kgProductPreviewModal = $('.kg-mystery-purchase-preview-modal');

    const kgPriceRegular = $(".kg-main-product-page-price").find(".price__regular");
    const kgPriceSale = $(".kg-main-product-page-price").find(".price__sale");

    let priceToShow = '';
    console.log('kgPriceRegular:', kgPriceRegular);
    console.log('kgPriceSale:', kgPriceSale);

    if (kgPriceRegular.length > 0 && kgPriceRegular.is(':visible')) {
      priceToShow =  $(".kg-main-product-page-price").find(".price-item.price-item--regular").html();
    } else {
      priceToShow =  $(".kg-main-product-page-price").find(".price-item.price-item--sale").html();
    }
    console.log('priceToShow:', priceToShow);

    kgProductPreviewModal.find(".kg-mystery-purchase-preview-price").html(priceToShow);
    $(".kg-card-head-price").html(priceToShow);
  });
  // $(document).on("click", ".kg-atc-mystery-product", async function () {
  //   // const kgProductVariantId = $(this).attr('data-variant-id');
  //   const kgProductPreviewModal = $('.kg-mystery-purchase-preview-modal');

  //   const kgLetestProductPrice = $(".kg-main-product-page-price").find(".price-item.price-item--regular");
  //   if (kgLetestProductPrice.length > 0) {
  //     kgProductPreviewModal.find(".kg-mystery-purchase-preview-price").html(kgLetestProductPrice.html());
  //   }
  // });


  $(document).on('click', '.kg-mystery-modal-continue-button', function () {
    const kgProductVariantId = $(this).attr('data-variant-id');
    console.log( kgProductFormSubmitBtn.first());
    $(".atc-button.product-form__submit").first().click();
  });

  
  function kgUpdateGPOProductPrice() {
    const kgProductPreviewModal = $('.kg-mystery-purchase-preview-modal');

    const kgPriceRegular = $(".kg-main-product-page-price").find(".price__regular");
    const kgPriceSale = $(".kg-main-product-page-price").find(".price__sale");

    let priceToShow = '';
    console.log('kgPriceRegular:', kgPriceRegular);
    console.log('kgPriceSale:', kgPriceSale);

    if (kgPriceRegular.length > 0 && kgPriceRegular.is(':visible')) {
      priceToShow = $(".kg-main-product-page-price").find(".price-item.price-item--regular").html();
    } else {
      priceToShow = $(".kg-main-product-page-price").find(".price-item.price-item--sale").html();
    }
    console.log('priceToShow:', priceToShow);

    kgProductPreviewModal.find(".kg-mystery-purchase-preview-price").html(priceToShow);
    $(".kg-card-head-price").html(priceToShow);
  }
});
